import React from 'react';
import Icon from '../../../components/AppIcon';

const ActionLogsTable = () => {
  const actionLogs = [
    {
      id: 'LOG001',
      action: 'Account Suspended',
      targetUser: 'USR12345',
      adminUser: 'Admin #001',
      reason: 'Multiple reports of inappropriate behavior',
      timestamp: '2026-01-28T09:15:00',
      severity: 'high'
    },
    {
      id: 'LOG002',
      action: 'Verification Approved',
      targetUser: 'USR67890',
      adminUser: 'Admin #002',
      reason: 'Documents verified successfully',
      timestamp: '2026-01-28T08:45:00',
      severity: 'low'
    },
    {
      id: 'LOG003',
      action: 'Warning Issued',
      targetUser: 'USR11223',
      adminUser: 'Admin #001',
      reason: 'Violation of community guidelines',
      timestamp: '2026-01-27T16:30:00',
      severity: 'medium'
    },
    {
      id: 'LOG004',
      action: 'Report Dismissed',
      targetUser: 'USR44556',
      adminUser: 'Admin #003',
      reason: 'No evidence of violation found',
      timestamp: '2026-01-27T14:20:00',
      severity: 'low'
    },
    {
      id: 'LOG005',
      action: 'Account Reinstated',
      targetUser: 'USR77889',
      adminUser: 'Admin #002',
      reason: 'Appeal approved after review',
      timestamp: '2026-01-27T11:10:00',
      severity: 'medium'
    }
  ];

  const getActionIcon = (action) => {
    if (action?.includes('Suspended')) return 'Ban';
    if (action?.includes('Approved')) return 'CheckCircle';
    if (action?.includes('Warning')) return 'AlertTriangle';
    if (action?.includes('Dismissed')) return 'X';
    if (action?.includes('Reinstated')) return 'RotateCcw';
    return 'FileText';
  };

  const getSeverityColor = (severity) => {
    switch (severity) {
      case 'high':
        return 'text-error bg-error/10';
      case 'medium':
        return 'text-warning bg-warning/10';
      case 'low':
        return 'text-success bg-success/10';
      default:
        return 'text-muted-foreground bg-muted';
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date?.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
  };

  return (
    <div className="bg-card rounded-xl shadow-warm overflow-hidden border border-border">
      <div className="p-4 md:p-6 border-b border-border">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-primary/10 rounded-lg">
            <Icon name="History" size={20} color="var(--color-primary)" />
          </div>
          <div>
            <h3 className="text-lg font-heading font-semibold">Action History</h3>
            <p className="text-sm text-muted-foreground">Recent administrative actions</p>
          </div>
        </div>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-border bg-muted/50">
              <th className="text-left p-3 md:p-4 text-xs md:text-sm font-caption font-semibold">Timestamp</th>
              <th className="text-left p-3 md:p-4 text-xs md:text-sm font-caption font-semibold">Action</th>
              <th className="text-left p-3 md:p-4 text-xs md:text-sm font-caption font-semibold">Target User</th>
              <th className="text-left p-3 md:p-4 text-xs md:text-sm font-caption font-semibold">Admin</th>
              <th className="text-left p-3 md:p-4 text-xs md:text-sm font-caption font-semibold">Reason</th>
              <th className="text-left p-3 md:p-4 text-xs md:text-sm font-caption font-semibold">Severity</th>
            </tr>
          </thead>
          <tbody>
            {actionLogs?.map((log) => (
              <tr key={log?.id} className="border-b border-border hover:bg-muted/20 transition-smooth">
                <td className="p-3 md:p-4 text-xs md:text-sm font-mono whitespace-nowrap">
                  {formatDate(log?.timestamp)}
                </td>
                <td className="p-3 md:p-4 text-xs md:text-sm">
                  <div className="flex items-center gap-2">
                    <Icon name={getActionIcon(log?.action)} size={16} />
                    <span className="font-medium">{log?.action}</span>
                  </div>
                </td>
                <td className="p-3 md:p-4 text-xs md:text-sm font-mono">
                  {log?.targetUser}
                </td>
                <td className="p-3 md:p-4 text-xs md:text-sm">
                  {log?.adminUser}
                </td>
                <td className="p-3 md:p-4 text-xs md:text-sm text-muted-foreground">
                  {log?.reason}
                </td>
                <td className="p-3 md:p-4">
                  <span className={`inline-flex items-center gap-1.5 px-2 md:px-3 py-1 rounded-full text-xs font-medium ${getSeverityColor(log?.severity)}`}>
                    {log?.severity?.charAt(0)?.toUpperCase() + log?.severity?.slice(1)}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ActionLogsTable;